export default __webpack_public_path__ + "static/media/quay.8d64efd8.svg";